import type {
  AdayDavetKodu,
  CarkDurumYaniti,
  CarkTabloIstegi,
  CarkYonetimDurumu,
  SinifDuzeyi,
  YonetimLiderlik,
} from "@koclukpanel/contracts";
import { api } from "./api";

/**
 * ÇARK / LİDERLİK / DAVET UÇLARI — panel (dalga 2 / 7b). İzin, kapsam ve sudo SUNUCUDA.
 * Sözleşme: packages/contracts/src/oyun-b.ts (tipler ve istek gövdeleri oradan; yol ve gövde sunucu controller'larıyla
 * aynıdır: `cark.controller.ts`, `liderlik.controller.ts`, `crm.controller.ts`).
 */

// --- Çark (`oyun.cark.yonet`, sudo) ---------------------------------------------------------------

export function carkYonetimDurumu(): Promise<CarkYonetimDurumu> {
  return api("/oyun/yonetim/cark/tablolar");
}

/** Çarkı açar/kapatır (`Settings.modules.gamificationWheel`). Kapalıyken öğrenci ucu 404; geçmiş korunur. */
export function carkDurumAyarla(acik: boolean): Promise<CarkDurumYaniti> {
  return api("/oyun/yonetim/cark/durum", { yontem: "POST", govde: { acik } });
}

/**
 * Yeni tablo sürümü (`oyun.cark.yonet`, sudo). `oncekiSurum` ekranda görülen etkin sürümdür: araya başkası sürüm
 * açtıysa sunucu 409 `SURUM_DEGISTI` döner (araya gireni sessizce ezmez). Yanıt: yeni etkin durum.
 */
export function carkTabloKaydet(govde: CarkTabloIstegi): Promise<CarkYonetimDurumu> {
  return api("/oyun/yonetim/cark/tablolar", { yontem: "POST", govde });
}

// --- Liderlik (`oyun.liderlik.goruntule`; kapsam sunucuda) -----------------------------------------

export function yonetimLiderligi(f: {
  sinif?: SinifDuzeyi;
  hafta?: string;
}): Promise<YonetimLiderlik> {
  return api("/oyun/yonetim/liderlik", { sorgu: { sinif: f.sinif, hafta: f.hafta } });
}

// --- CRM davet kodu (aday düzenleme izni) -----------------------------------------------------------

/** Kodu satış personeli adaya girer; aday kodu kendisi söyler. Doğrulama (etkin kod, kendi kendini davet yok) sunucuda. */
export function adayDavetKoduGir(adayId: string, kod: string): Promise<AdayDavetKodu> {
  return api(`/crm/adaylar/${encodeURIComponent(adayId)}/davet-kodu`, {
    yontem: "POST",
    govde: { kod },
  });
}
